var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1998 2.5002V9.7002C15.1998 10.6943 14.3939 11.5002 13.3998 11.5002H8.89981L4.3998 15.1002V11.5002H2.5998C1.60569 11.5002 0.799805 10.6943 0.799805 9.7002V2.5002C0.799805 1.50608 1.60569 0.700195 2.5998 0.700195H13.3998C14.3939 0.700195 15.1998 1.50608 15.1998 2.5002ZM5.2998 5.2002H3.4998V7.0002H5.2998V5.2002ZM7.0998 5.2002H8.89981V7.0002H7.0998V5.2002ZM12.4998 5.2002H10.6998V7.0002H12.4998V5.2002Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.ceef7b9ecad2555c40d525cac93f218f.svg";
export { ForwardRef as ReactComponent };